import React, { useEffect, useState } from 'react';
import { FaPrint } from 'react-icons/fa';
import Input from '../../../../../components/Input';
import Popup from '../../../../../components/Popup';
import companyServices from '../../../../../services/admFin/companyServices';
import partnerServices from '../../../../../services/admFin/partnerServices';
import reportServices from '../../../../../services/reportServices';
import { PopupSelectPartners } from './PopupSelectPartners';

import './styles.css';


export function PopupCompanyReport(props) {
    const [fileName, setFileName] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [partners, setPartners] = useState([]);
    const [selectedPartners, setSelectedPartners] = useState([]);
    const [visibilitySelectPartners, setVisibilitySelectPartners] = useState(false);

    async function getPartners () {
        try {
            const response = await partnerServices.getPartners();
            setPartners(response.data);
        } catch(err) {
            console.log(err);
            alert("Erro ao ler parceiros");
        }
    }

    async function generateReport () {
        try {
            const response = await companyServices.getCompanyBills(props.companyInfo.id, selectedPartners, startDate, endDate);
            
            reportServices.generateReportCompanyBills(response.data, `Relatório da empresa ${props.companyInfo.nome} de ${startDate.split("-").reverse().join("/")} até ${endDate.split("-").reverse().join("/")}`, null,fileName);
            props.setVisibility(false);
        } catch(err) {
            console.log(err.message);
            alert("Erro ao gerar relatório");
        }
    }

    useEffect(() => {
        getPartners();
    }, [])
    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            tittle="Relatório da Empresa"
            icon={<FaPrint/>}
        >
            <div className='company-report-popup-container'>
                <Input
                //type="text"
                label="Nome do Documento"
                placeholder="Escreva aqui o nome do arquivo"
                onChange={(e) => setFileName(e.target.value)}
                value={fileName}
                />
                <div className='company-report-popup-date-container'>
                    <Input
                    label="Data de Início*"
                    type="date"
                    onChange={(e) => setStartDate(e.target.value)}
                    value={startDate}
                    />
                    <Input
                    label="Data de Fim*"
                    type="date"
                    onChange={(e) => setEndDate(e.target.value)}
                    value={endDate}
                    />
                </div>

                <button className='light-blue' onClick={() => setVisibilitySelectPartners(true)}>
                    {`${selectedPartners.length} parceiros selecionados`}
                </button>

                <PopupSelectPartners
                    visibility={visibilitySelectPartners}
                    setVisibility={setVisibilitySelectPartners}
                    partners={partners}
                    selectedPartners={selectedPartners}
                    setSelectedPartners={setSelectedPartners}
                />

                <button
                    onClick={generateReport}
                >
                    Gerar Relatório
                </button>
            </div>


        </Popup>
    )
}